{
    "IncludeintransitioningsequenceLabel": "Include In Report Transitioning Display Sequence:",
    "RptdisplintervaltimeLabel": "Report Display Interval Time:",
    "RptdisplintervaltimePlaceholder": "5s",
    "NAME": "DisplaySwitching",
    "DisplaySwitching_SectionHeader": "Automatic Report Display Switching"
}